import {nav} from './nav';
import {outdated_flash} from './outdated-flash';


const init = () => {
  document.addEventListener('turbolinks:load', () => {
    nav();
    outdated_flash();

    const main_visual = document.querySelector('#main_visual');
    if (main_visual) {
      main_visual.addEventListener('load', () => {
        document.body.classList.add('loaded');
      })
    }
  });
}

export default init;
